<template>
  <v-chip
    small
    :color="color"
    outlined
    class="mr-1 mb-1"
    :href="driveUrl"
    :target="driveUrl ? '_blank' : undefined"
    :rel="driveUrl ? 'noopener noreferrer' : undefined"
    :style="driveUrl ? 'cursor: pointer;' : undefined"
  >
    <v-icon left x-small>mdi-file-outline</v-icon>
    {{ file.name }}
    <v-icon v-if="driveUrl" right x-small>mdi-open-in-new</v-icon>
  </v-chip>
</template>

<script>
export default {
  name: 'FileChip',
  props: {
    file: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    driveUrl() {
      return this.file.id
        ? `https://drive.google.com/file/d/${this.file.id}/view`
        : null
    },
  },
}
</script>
